export const REGISTER_FORM = "REGISTER_FORM";
export const REGISTER_FIELDS = "REGISTER_FIELDS";
export const UPDATE_VALUE = "UPDATE_VALUE";
export const SYNC_ERRORS = "SYNC_ERRORS";
export const RESET_FORM = "RESET_FORM";
export const RESET_FIELD = "RESET_FIELD";
export const UNREGISTER_FIELDS = "UNREGISTER_FIELDS";
export const UPDATE_FIELD_META = "UPDATE_FIELD_META";
